<template>

    <!-- szkielet bootstrapowego modala, srodek w stylistyce cf-modal
         (redesign z CardFinance2); logika zmiany hasla bez zmian -->
    <div class="modal fade" ref="modal" id="passChangeDialog" tabindex="-1" >

      <div class="modal-dialog modal-dialog-centered cf-modal-dialog">
        <div class="modal-content cf cf-modal">

          <div class="cf-modal__head">
            <div class="cf-stack" style="gap:6px">
              <h2 class="cf-h2" style="font-size:23px">Zmiana hasła</h2>
              <p class="cf-meta" style="margin:0">Nowe hasło musi mieć co najmniej 6 znaków.</p>
            </div>
            <button type="button" class="cf-modal__close" data-bs-dismiss="modal" aria-label="Zamknij">×</button>
          </div>

          <form class="cf-modal__body" novalidate @submit.prevent="!$v.creds.$invalid && doChange()">

            <div class="cf-field">
              <label class="cf-field__label" for="pc-old">Aktualne hasło</label>
              <input ref="input" id="pc-old" type="password" class="cf-input" autocomplete="current-password"
                     :data-error="$v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty ? 'true' : null"
                     :data-valid="!$v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty ? 'true' : null"
                     v-model="creds['old_pass']" @input="$v.creds.old_pass.$touch();">
              <span v-if="$v.creds.old_pass.$invalid && $v.creds.old_pass.$dirty" class="cf-field__error">Wprowadź aktualne hasło.</span>
            </div>

            <div class="cf-field">
              <label class="cf-field__label" for="pc-new">Nowe hasło</label>
              <input id="pc-new" type="password" class="cf-input" autocomplete="new-password"
                     :data-error="$v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty ? 'true' : null"
                     :data-valid="!$v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty ? 'true' : null"
                     v-model="creds['new_pass']" @input="$v.creds.new_pass.$touch();">
              <span v-if="$v.creds.new_pass.$invalid && $v.creds.new_pass.$dirty" class="cf-field__error">Nowe hasło musi mieć min. 6 znaków.</span>
            </div>

            <div class="cf-field">
              <label class="cf-field__label" for="pc-new2">Powtórz nowe hasło</label>
              <input id="pc-new2" type="password" class="cf-input" autocomplete="new-password"
                     :data-error="$v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty ? 'true' : null"
                     :data-valid="!$v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty ? 'true' : null"
                     v-model="creds['repeat_pass']" @input="$v.creds.repeat_pass.$touch();">
              <span v-if="$v.creds.repeat_pass.$invalid && $v.creds.repeat_pass.$dirty" class="cf-field__error">Hasła nie są takie same.</span>
            </div>

            <span v-if="err" class="cf-field__error" v-dynamic="err"></span>

            <button type="submit" class="cf-btn cf-btn--primary cf-btn--block"
                    :aria-disabled="$v.creds.$invalid ? 'true' : 'false'">Zmień hasło</button>

          </form>

        </div>
      </div>

    </div>

</template>

<script>

  
  import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';

  import { bus } from '@/main';


  export default {

    name: 'PassChange',

    data() {
      return {


        creds: {},


        err: '',

        modal:null

      }
    },
    methods: {

      doChange() {


        this.post( '/client/password', {
          client_password: this.creds.new_pass.trim()
        } )
          .then(response => {

            if (!!response.data) {           
              if (!(response.data.IS_ERROR | 0)) {

                this.modal.hide();

                this.toast('Hasło zmienione!');
              }
            }           
          })
          .catch(error => {


            this.err = typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors;
                                
          });









    //    this.$emit('login');


/*          axios.post( __CFG.secondaryEndpoint + '/client/login', {

            client_login: this.creds.user.trim(),
            client_password: this.creds.passwd.trim()

          })
          .then(response => {

         //   page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);        



           //   console.log('okkk ' + ok)       


            //  console.log(response.data)

              bus.$emit('logged_in');


              localStorage.setItem('user', JSON.stringify(response.data));

              this.modal.hide();

              this.$router.push({path: 'client'});   
                   
            
            }
           

          })
          .catch(error => {
          //  console.log(error);
           

          //    page.isLoading = false;
        

              // Error 
              if (error.response) {


               // console.log(error.response.data);
                 

                  if (!!error.response.data.IS_ERROR) {


                    this.err = true; //{...error.response.data.Message};

                    //this.verifycode_hint = error.response.data.Message.toString();
                  }
                
              } 
            

              //this.form['verifycode'] = '';
              //this.$v.form['verifycode'].$touch();                         

            //console.log('Network error', error);

          });

*/


        

      }
     
    },


    validations(){

      return {
        creds: {
          old_pass: {
            required,
            minLength: minLength(6)
          },

          new_pass: {
            required,
            minLength: minLength(6)
          },

          repeat_pass: {
            required,
            sameAsPassword: sameAs('new_pass')
          }
        }
      }
    },


    computed: {


      invalidOld() {
        return this.isDirty && !this.creds['old_pass']
      },

      invalidPassword() {
        return this.isDirty && !this.creds['passwd']
      },

      invalidCreds() {
        return this.isDirty && this.err
      }
    },



    created() {

      // nasluch trzymamy w polu, zeby zdjac go w beforeDestroy - komponent zyje
      // tylko na /client, a listener na busie zostawal po kazdym wejsciu do strefy
      // klienta. Stara instancja otwierala wtedy modal na odpietym z DOM elemencie:
      // bootstrap dokladal backdrop bez okna i po zamknieciu widocznego modala
      // "maska" zostawala na stronie
      this._onPassChangeDialog = () => {

        this.modal && this.modal.show();
      };

      this.listen('pass_change_dialog', this._onPassChangeDialog);
    },


    mounted(){

      this.modal = new bootstrap.Modal(this.$refs['modal']);
    },


    beforeDestroy(){

      bus.$off('pass_change_dialog', this._onPassChangeDialog);

      if (this.modal) {

        this.modal.hide();
        this.modal.dispose();
        this.modal = null;
      }

      // sprzatniecie osieroconych backdropow (gdyby jakis zostal po poprzednich wejsciach)
      if (!document.querySelector('.modal.show')) {

        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }


  }



</script>
<style scoped>
/* wyglad modala: cf-modal w src/assets/cf-theme.css */
</style>



// WEBPACK FOOTER //
// src/components/PassChange.vue